import { THEME_COLOR_CONFIG } from "config/themeColors";
import { withAlpha } from "utils/colorUtils";

// ==============================|| OVERRIDES - LIST ITEM ICON ||============================== //

export default function ListItemButton(theme) {
  const baseBg = withAlpha(
    theme.vars.palette.primary.main,
    theme.palette.mode === "dark"
      ? THEME_COLOR_CONFIG.selection.baseBgAlphaDark
      : THEME_COLOR_CONFIG.selection.baseBgAlphaLight,
  );
  const hoverBg = withAlpha(
    theme.vars.palette.primary.main,
    theme.palette.mode === "dark"
      ? THEME_COLOR_CONFIG.selection.hoverBgAlphaDark
      : THEME_COLOR_CONFIG.selection.hoverBgAlphaLight,
  );
  const selectedBorder = withAlpha(
    theme.vars.palette.primary.main,
    theme.palette.mode === "dark"
      ? THEME_COLOR_CONFIG.selection.selectedBorderAlphaDark
      : THEME_COLOR_CONFIG.selection.selectedBorderAlphaLight,
  );

  return {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          backgroundColor: baseBg,
          "&:hover": {
            backgroundColor: hoverBg,
          },
          '&.Mui-selected': {
            color: theme.vars.palette.primary.main,
            backgroundColor: baseBg,
            borderColor: selectedBorder,
            '& .MuiListItemIcon-root': {
              color: theme.vars.palette.primary.main
            },
          },
          "&.Mui-selected:hover": {
            backgroundColor: hoverBg,
          }
        }
      }
    }
  };
}
